import { useCallback, useState } from 'react'
import { Button, Card, BookSizeSelector } from '@/ui/components'
import {
  BookDefault,
  BookSizes,
  bookFormats,
} from '@/ui/pages/PreviewPDF/createPdf/PdfBook'
import styled from 'styled-components'
import { CoverForm, CoverFormData } from './CoverForm'
import { PageForm, PageFormData } from './PageForm'
import { BookFormat } from '@/ui/pages/PreviewPDF/createPdf/types'

const StyledCard = styled(Card)`
  gap: 20px;
  min-width: 450px;
`

interface Props {
  handleBook: (book: BookFormat) => void
}
/**
 * 1. Book size selection
 * 2. Cover selection
 * 3. Page selection
 */
export const BookBuilder: React.FC<Props> = (props) => {
  const [step, setStep] = useState<'size' | 'cover' | 'page'>('size')
  const [bookSize, setBookSize] = useState<BookDefault>(
    bookFormats['large-square'],
  )
  const [cover, setCover] = useState<CoverFormData>()
  const [page, setPage] = useState<PageFormData>()

  const { handleBook } = props

  const handleCover = useCallback(
    (coverData: CoverFormData) => {
      setCover(coverData)
      setStep('page')
    },
    [setCover, setStep],
  )

  const handleBookFormat = useCallback(
    (page: PageFormData) => {
      const bookFormat: BookFormat = {
        dimensions: {
          height: bookSize.dimensions.height,
          width: bookSize.dimensions.width,
        },
        cover: {
          image: cover!.coverImage!,
          title: cover!.coverTitle,
          fontSize: cover?.coverFontSize ?? bookSize.cover.fontSize,
          customFont: cover!.coverFont,
        },
        page: {
          fontSize: page?.pageFontSize ?? bookSize.page.fontSize,
          customFont: page.pageFont,
        },
        entriesPerPage: page?.entriesPerPage ?? bookSize.entriesPerPage,
      }
      handleBook(bookFormat)
    },
    [cover, bookSize, handleBook],
  )

  return (
    <StyledCard>
      {step === 'size' ? (
        <>
          <BookSizeSelector
            onSelect={(selected) =>
              setBookSize(bookFormats[selected.value as BookSizes])
            }
          />
          <Button onClick={() => setStep('cover')}>Next</Button>
        </>
      ) : step === 'cover' ? (
        <CoverForm
          bookSize={bookSize}
          initialValues={cover}
          handleBack={() => setStep('size')}
          onSubmit={(data) => handleCover(data)}
        />
      ) : (
        <PageForm
          bookSize={bookSize}
          initialValues={page}
          handleBack={() => setStep('cover')}
          onSubmit={(data) => {
            setPage(data)
            console.log('PAGE DATA', data)
            handleBookFormat(data)
          }}
        />
      )}
    </StyledCard>
  )
}
